import { useQuery } from '@tanstack/react-query';

import { packagingApi } from 'api/packaging';

export const packagingPurchaseOrderQueryKeys = {
    all: ['packagingPurchaseOrders'],
    searchPaginated: (params) => ['packagingPurchaseOrders', 'v2', 'search', 'paginated', params],
};

/**
 * Hook for single-page packaging purchase order search (cursor-based pagination).
 * Mirrors usePurchaseOrdersV2Search for the packaging PO list.
 *
 * @param {Object} params - Search parameters including filters and pagination (pageSize, cursor, totalCount)
 * @param {Object} options - React Query options
 * @returns {import('@tanstack/react-query').UseQueryResult<{rows: Array, pagination: {hasMore, nextCursor, totalCount}, deptLeadCheck?: boolean}, Error>}
 */
export const usePackagingPurchaseOrdersV2Search = (params = {}, options = {}) =>
    useQuery({
        queryKey: packagingPurchaseOrderQueryKeys.searchPaginated(params),
        queryFn: async ({ signal }) => {
            const response = await packagingApi.searchPackagingPurchaseOrdersV2(params, { signal });
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch packaging purchase orders');
            }
            return response.data;
        },
        staleTime: 30 * 1000,
        ...options,
    });
